export const VENDOR_ELE_FILE_CONFIG_FETCHING =
  'VENDOR_ELE_FILE_CONFIG_FETCHING';
export const VENDOR_ELE_FILE_CONFIG_FETCH = 'VENDOR_ELE_FILE_CONFIG_FETCH';
export const VENDOR_ELE_FILE_CONFIG_FETCH_ERROR =
  'VENDOR_ELE_FILE_CONFIG_FETCH_ERROR';
export const VENDOR_ELE_FILE_CONFIG_SUBMITTING =
  'VENDOR_ELE_FILE_CONFIG_SUBMITTING';
export const VENDOR_ELE_FILE_CONFIG_SUBMIT = 'VENDOR_ELE_FILE_CONFIG_SUBMIT';
export const VENDOR_ELE_FILE_CONFIG_SUBMIT_ERROR =
  'VENDOR_ELE_FILE_CONFIG_SUBMIT_ERROR';
export const VENDOR_ELE_FILE_CONFIG_CLEAR_ERROR_SUCCESS =
  'VENDOR_ELE_FILE_CONFIG_CLEAR_ERROR_SUCCESS';
export const VENDOR_ELE_FILE_CONFIG_CLEAR_DATA =
  'VENDOR_ELE_FILE_CONFIG_CLEAR_DATA';



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/state/eleFileConfig/types.js